// 深拷贝
export function deepCopyFn(value) {
  if (!value) return null
  let str = JSON.stringify(value)
  let obj = JSON.parse(str)
  return obj
}
// id 随机生成
export function getUniqueRandomSet(min = 1, max = 999, count = 1) {
  const uniqueId = `${Date.now()}-${Math.random().toString(36).slice(2)}-custid`
  return uniqueId
}
// 去除空格
export function trimAll(value) {
  return value?.replace?.(/\s+/g, '') || ''
}
/**
 * 格式化日期
 * @param {Date} date - 要格式化的日期对象
 * @param {string} format - 格式字符串，例如："YYYY-MM-DD HH:mm:ss"
 * @returns {string} 格式化后的日期字符串
 */
export function custFormatDate(date, format = 'YYYY-MM-DD') {
  const d = new Date(date)
  if (isNaN(d.getTime())) return ''
  if (!date) return ''

  const parts = {
    YYYY: d.getFullYear(),
    MM: String(d.getMonth() + 1).padStart(2, '0'),
    DD: String(d.getDate()).padStart(2, '0'),
    HH: String(d.getHours()).padStart(2, '0'),
    mm: String(d.getMinutes()).padStart(2, '0'),
    ss: String(d.getSeconds()).padStart(2, '0'),
  }

  return format.replace(/YYYY|MM|DD|HH|mm|ss/g, match => parts[match])
}
export function getCurrentTime() {
  const now = new Date()
  const hours = now.getHours().toString().padStart(2, '0')
  const minutes = now.getMinutes().toString().padStart(2, '0')
  return `${hours}:${minutes}`
}

/**
 * 年龄格式化函数
 * @param {number} ageYear - 年龄年数
 * @param {number} ageMonth - 年龄月数
 * @param {number} ageDay - 年龄天数
 * @returns {string} 格式化后的年龄字符串
 */
export function formatAge(ageYear, ageMonth, ageDay) {
  // 如果有年龄年数，则展示x岁x月
  if (ageYear && ageYear > 0) {
    const yearStr = `${ageYear}岁`
    const monthStr = ageMonth && ageMonth > 0 ? `${ageMonth}月` : ''
    return monthStr ? `${yearStr}${monthStr}` : yearStr
  }

  // 如果没有年龄年数，则展示x月x天
  const monthStr = ageMonth && ageMonth > 0 ? `${ageMonth}月` : ''
  const dayStr = ageDay && ageDay > 0 ? `${ageDay}天` : ''

  if (monthStr && dayStr) {
    return `${monthStr}${dayStr}`
  } else if (monthStr) {
    return monthStr
  } else if (dayStr) {
    return dayStr
  }

  return '0天'
}
